import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiListItemIcon(theme: Theme): Components['MuiListItemIcon'] {
  return {
    styleOverrides: {
      root: {
        color: 'inherit',
        minWidth: 'auto',
        marginRight: theme.spacing(2),
        fontSize: 20,
      },
    },
  };
}
